// Test IDs for Workout Cues settings + paced-rep + voice-command surfaces.
export const CUES = {
    section: 'cues-section',
    tempoEcc: 'cues-tempo-eccentric',
    tempoBot: 'cues-tempo-pause-bottom',
    tempoCon: 'cues-tempo-concentric',
    tempoTop: 'cues-tempo-pause-top',
    restCompound: 'cues-rest-compound',
    restIsolation: 'cues-rest-isolation',
    cueModeOff: 'cues-mode-off',
    cueModeBeeps: 'cues-mode-beeps',
    cueModeVoice: 'cues-mode-voice',
    repPacingToggle: 'cues-rep-pacing-toggle',
    voiceCmdToggle: 'cues-voice-command-toggle',
    save: 'cues-save-btn',
    // Paced-rep player surfaces (inside active session)
    pacerOverlay: 'pacer-overlay',
    pacerPhase: 'pacer-phase',
    pacerRepCount: 'pacer-rep-count',
    pacerStartBtn: 'pacer-start-btn',
    pacerStopBtn: 'pacer-stop-btn',
    // Voice command surfaces
    voiceMicToggle: 'voice-mic-toggle',
    voiceMicStatus: 'voice-mic-status',
};
